
import Api from "../../apis/api";
const apiEndpoint = "user/?";
const apiEndpoint_cblu_mapping = "cblu-mapping/?";

export default {
 
  getall() {
   
    let apiurl = "user/?" ;
    //alert(apiurl);
    return Api.get(apiurl);
   
  },
  getbyid(varid) {
     
    let apiurl = apiEndpoint + "id=" + varid;
    //alert('dd'+apiurl);
    return Api.get(apiurl);
  },
  update(id,username,loginid,isactive,password,ischangepwd,canshare) {
    var createdby=localStorage.getItem('SET_USERID');
    let apiurl = apiEndpoint + "id="+id+"&username="+ username +"&loginid="+ loginid +"&createdby="+ createdby +"&isactive="+ isactive +"&canshare=" +canshare;
    if(ischangepwd)
    {
      apiurl = apiEndpoint + "id="+id+"&username="+ username +"&password="+ password +"&loginid="+ loginid +"&createdby="+ createdby +"&isactive="+ isactive +"&canshare=" +canshare;
    }
    //alert(apiurl);
    
    return Api.get(apiurl);
  },
  addNew(username, password, loginid,isactive,canshare) {
    var createdby=localStorage.getItem('SET_USERID');
    let apiurl = "user/?username="+ username +"&password="+ password +"&loginid="+ loginid +"&createdby="+ createdby +"&isactive="+ isactive +"&canshare=" +canshare;
    alert(apiurl);
    return Api.get(apiurl);
  },
  delete(id) {
    let apiurl = apiEndpoint + "id=" + id + "&isdisable=true";
    //alert(apiurl);
    return Api.get(apiurl);
  },
//cblu-mapping
cbluGetAll()
{
  let apiurl = apiEndpoint_cblu_mapping;
    //alert(apiurl);
    return Api.get(apiurl);
},
cbluGetbyId(id)
{
  let apiurl = apiEndpoint_cblu_mapping+ "id=" + id ;
    //alert(apiurl);
    return Api.get(apiurl);
},
// app
apicall_app()
{
  let apiurl = "app";
    //alert(apiurl);
    return Api.get(apiurl);
},
apicall_userappaccess(varuserid)
{
  const config = {
    headers:{
      'X-Requested-With': 'XMLHttpRequest'
     
    },
    params: {
      id: 'klijuu'
    }
  };
  let apiurl = "userappaccess/?user_id="+varuserid;
    //alert(apiurl);
    return Api.get(apiurl,config);
},
apicall_userapp_mapp(varuserid,varappid)
{
  let apiurl = "mapuserapp/?user="+varuserid+"&app="+varappid+"";
   // alert(apiurl);
    return Api.get(apiurl);
},
apicall_userapp_unmapp(varmappid)
{
    let apiurl = "mapuserapp/?id="+varmappid+"&isdisable=1";
    // alert(apiurl);
    return Api.get(apiurl);
},
apicall_userapp_remapp(varmappid)
{
    let apiurl = "mapuserapp/?id="+varmappid+"&isdisable=0";
    // alert(apiurl);
    return Api.get(apiurl);
}, 
apicall_getapplicence()
{
    let apiurl = "availablelicense";
   // alert(apiurl);
    return Api.get(apiurl);
}, 
// datamanagenment
apicall_get_available_data()
{
    let apiurl = "get_available_data";
   // alert(apiurl);
    return Api.get(apiurl);
}, 
apicall_get_available_databyuser(varuserid)
{
    let apiurl = "mapuserdata/?user="+varuserid;
    // alert(apiurl);
    return Api.get(apiurl);
}, 
apicall_get_mappuserdata(varuserid,vardata)
{
    let apiurl = "mapuserdata/?user="+varuserid+"&data="+vardata;
 //    alert(apiurl);
    return Api.get(apiurl);
},
apicall_get_unmappuserdata(varuserid,vardata)
{
    let apiurl = "mapuserdata/?user="+varuserid+"&data="+vardata+"&isdisable=1";
   //  alert(apiurl);
    return Api.get(apiurl);
},
apicall_get_remappuserdata(varuserid,vardata)
{
    let apiurl = "mapuserdata/?user="+varuserid+"&data="+vardata+"&isdisable=0";
     //alert(apiurl);
    return Api.get(apiurl);
},   
};
